// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { baseUrl } from "../../boot/index";
// import axios from "axios";


// // leadReduxApi.js mein yeh function add karein
// const hasFullAccessToAllModules = () => {
//   try {
//     const permissionsString = localStorage.getItem("permissions");
//     if (!permissionsString) return false;

//     const permissions = JSON.parse(permissionsString);
    
//     // Check if user has all modules with full permissions
//     return permissions.every(module => 
//       module.add && 
//       module.viewAll && 
//       module.fullAccess && 
//       module.modifyAll && 
//       module.delete && 
//       module.assignOwner &&
//       // Also check subModules if they exist
//       (!module.subModules || module.subModules.every(subModule => 
//         subModule.add && 
//         subModule.viewAll && 
//         subModule.fullAccess && 
//         subModule.modifyAll && 
//         subModule.delete && 
//         subModule.assignOwner
//       ))
//     );
//   } catch (error) {
//     console.error("Error checking permissions:", error);
//     return false;
//   }
// };



// // export const getLeads = createAsyncThunk("lead/get-lead", async (data) => {
// //   let path = null;
// //   console.log("dataaaaaa", data);

// //   // Map roles to their respective API endpoints
// //   const roleApiMap = {
// //     "Field Sale": "get-related-lead-list-new",
// //     "Tele Sale": "get-related-lead-list-contected",
// //     "Senior Telesales": "get-related-lead-list-contected",
// //     "Pre Sale": "get-related-lead-convertedtodeal",
// //     "Imported Lead": "/get-related-import-lead",
// //     "Telesale Manager" :"get-related-lead-list-tele-sales-manager",
// //     "Kyc Department" :"get-related-lead-list-department",
// //     "Surveyor" :"get-related-lead-list-department",
// //   };

// //   // If role is provided, use the mapped API path
// //   if (data?.role && roleApiMap[data?.role]) {
// //     path = `${baseUrl}cleaningappfunctions/crm/app/v1/${roleApiMap[data?.role]}`;
// //   }
// //   // If fetching leads by ID
// //   else if ((data.page === undefined || data.page === null) && data.id !== undefined && data.id !== null) {
// //     path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-leads/${data.id}`;
// //   }
// //   // Default lead fetching path
// //   else {
// //     path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-leads`;
// //   }

// //   const token = localStorage.getItem("authToken");
// //   console.log("path", path); 
// //     console.log("path", path);
// //   try {
// //     const response = await axios.post(
// //       path,
// //       {
// //         page: data?.page,
// //         size: data?.size,
// //         search: data?.search,
// //         userId: data?.leadOwner || data?.userId, // Use leadOwner if available, otherwise use userId
// //         // userId: data?.userId,
// //         role:data?.role
// //       },
// //       {
// //         headers: {
// //           "auth-token": token,
// //         },
// //       }
// //     )
// //   return response
// // }
// //    catch (error) {
// //     console.error("Error fetching leads - ", error);
// //     throw error;
// //   }
// // });

// export const getLeads = createAsyncThunk("lead/get-lead", async (data) => {
//   let path = null;
//   console.log("dataaaaaa", data);

//   // Map roles to their respective API endpoints
//   const roleApiMap = {
//     "Field Sale": "get-related-lead-list-new",
//     "Tele Sale": "get-related-lead-list-contected", 
//     "Senior Telesales": "get-related-lead-list-contected",
//     "Pre Sale": "get-related-lead-convertedtodeal",
//     "Imported Lead": "/get-related-import-lead",
//     "Telesale Manager": "get-related-lead-list-tele-sales-manager",
//     "Kyc Department": "get-related-lead-list-department",
//     "Surveyor": "get-related-lead-list-department",
//   };

//   // Check if user has full access to all modules
//   const hasFullAccess = hasFullAccessToAllModules();

//   // If role is provided, use the mapped API path
//   if (data?.role && roleApiMap[data?.role]) {
//     path = `${baseUrl}cleaningappfunctions/crm/app/v1/${roleApiMap[data?.role]}`;
//   }
//   // If fetching leads by ID - ONLY if user has full access to all modules
//   else if ((data.page === undefined || data.page === null) && data.id !== undefined && data.id !== null) {
//     if (hasFullAccess) {
//       path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-leads/${data.id}`;
//     } else {
//       throw new Error("Access denied: User does not have full permissions for all modules");
//     }
//   }
//   // Default lead fetching path - ONLY if user has full access to all modules
//   else {
//     if (hasFullAccess) {
//       path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-leads`;
//     } else {
//       // Agar full access nahi hai, toh role-based API use karein ya error throw karein
//       // Ya phir default role set karein based on user's actual permissions
//       const userRole = data?.role || "Field Sale"; // Default role set karein
//       if (roleApiMap[userRole]) {
//         path = `${baseUrl}cleaningappfunctions/crm/app/v1/${roleApiMap[userRole]}`;
//       } else {
//         throw new Error("Access denied: User does not have sufficient permissions");
//       }
//     }
//   }

//   const token = localStorage.getItem("authToken");
//   console.log("API Path:", path);

//   try {
//     const response = await axios.post(
//       path,
//       {
//         page: data?.page,
//         size: data?.size,
//         search: data?.search,
//         userId: data?.leadOwner || data?.userId,
//         role: data?.role
//       },
//       {
//         headers: {
//           "auth-token": token,
//         },
//       }
//     );
//     return response;
//   } catch (error) {
//     console.error("Error fetching leads - ", error);
//     throw error;
//   }
// });




import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// Permission check function
const hasFullAccessToAllModules = () => {
  try {
    const permissionsString = localStorage.getItem("permissions");
    if (!permissionsString) return false;

    const permissions = JSON.parse(permissionsString);
    
    return permissions.every(module => 
      module.add && 
      module.viewAll && 
      module.fullAccess && 
      module.modifyAll && 
      module.delete && 
      module.assignOwner &&
      (!module.subModules || module.subModules.every(subModule => 
        subModule.add && 
        subModule.viewAll && 
        subModule.fullAccess && 
        subModule.modifyAll && 
        subModule.delete && 
        subModule.assignOwner
      ))
    );
  } catch (error) {
    console.error("Error checking permissions:", error);
    return false;
  }
};

// Get user's actual permissions for role-based access
const getUserPermissions = () => {
  try {
    const permissionsString = localStorage.getItem("permissions");
    return permissionsString ? JSON.parse(permissionsString) : [];
  } catch (error) {
    console.error("Error getting user permissions:", error);
    return [];
  }
};

// Optimized API mapping with status filtering
const getOptimizedApiPath = (data, hasFullAccess) => {
  const roleApiMap = {
    "Field Sale": "get-related-lead-list-new",
    "Tele Sale": "get-related-lead-list-contected", 
    "Senior Telesales": "get-related-lead-list-contected",
    "Pre Sale": "get-related-lead-convertedtodeal",
    "Imported Lead": "get-related-import-lead",
    "Telesale Manager": "get-related-lead-list-tele-sales-manager",
    "Kyc Department": "get-related-lead-list-department",
    "Surveyor": "get-related-lead-list-department",
    "All": "get-leads" // Only for full access users
  };

  // If fetching single lead by ID
  if ((data.page === undefined || data.page === null) && data.id !== undefined && data.id !== null) {
    if (hasFullAccess) {
      return `${baseUrl}cleaningappfunctions/crm/app/v1/get-leads/${data.id}`;
    } else {
      throw new Error("Access denied: User does not have full permissions for all modules");
    }
  }

  // If role is provided, use the mapped API path
  if (data?.role && roleApiMap[data?.role]) {
    return `${baseUrl}cleaningappfunctions/crm/app/v1/${roleApiMap[data?.role]}`;
  }

  // Default: Use role-based API or full access API
  if (hasFullAccess) {
    return `${baseUrl}cleaningappfunctions/crm/app/v1/get-leads`;
  } else {
    // Get user's actual permissions to determine default role
    const permissions = getUserPermissions();
    const leadModule = permissions.find(module => module.moduleName === "Lead");
    const subModules = leadModule?.subModules || [];
    
    // Find the first role that user has access to
    const userRole = subModules.find(sub => sub.viewAll || sub.viewOwn)?.moduleName || "Field Sale";
    
    if (roleApiMap[userRole]) {
      return `${baseUrl}cleaningappfunctions/crm/app/v1/${roleApiMap[userRole]}`;
    } else {
      throw new Error("Access denied: User does not have sufficient permissions for any lead module");
    }
  }
};

// Optimized payload builder
const buildPayload = (data, hasFullAccess) => {
  const basePayload = {
    page: data?.page || 1,
    size: data?.size || 30,
    search: data?.search || "",
    role: data?.role || ""
  };

  // Add userId only if user doesn't have full access
  if (!hasFullAccess) {
    basePayload.userId = data?.userId || localStorage.getItem("userId");
  }

  return basePayload;
};

export const getLeads = createAsyncThunk("lead/get-lead", async (data) => {
  try {
    const hasFullAccess = hasFullAccessToAllModules();
    const path = getOptimizedApiPath(data, hasFullAccess);
    const payload = buildPayload(data, hasFullAccess);
    const token = localStorage.getItem("authToken");

    console.log("API Path:", path);
    console.log("Payload:", payload);

    const response = await axios.post(
      path,
      payload,
      {
        headers: {
          "auth-token": token,
        },
        timeout: 30000, // 30 seconds timeout
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    
    // Better error handling
    if (error.response) {
      // Server responded with error status
      throw new Error(error.response.data.message || "Failed to fetch leads");
    } else if (error.request) {
      // Network error
      throw new Error("Network error: Unable to connect to server");
    } else {
      // Other errors
      throw new Error(error.message || "Failed to fetch leads");
    }
  }
});

// Optimized related list API
export const getLeadRelatedList = createAsyncThunk("lead/get-related-list", async (id) => {
  const token = localStorage.getItem("authToken");
  
  try {
    const response = await axios.get(
      `${baseUrl}cleaningappfunctions/crm/app/v1/get-related-list/${id}`,
      {
        headers: {
          "auth-token": token,
        },
        timeout: 15000, // 15 seconds timeout for related data
      }
    );
    
    return response;
  } catch (error) {
    console.error("Error fetching related list:", error);
    throw error;
  }
});

// Count leads API - Optimized
export const countLeads = createAsyncThunk("lead/count-leads", async (role = "") => {
  const token = localStorage.getItem("authToken");
  const hasFullAccess = hasFullAccessToAllModules();
  
  try {
    let path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-count-leads`;
    
    // Use role-specific count APIs if available and user doesn't have full access
    if (!hasFullAccess && role) {
      const countApiMap = {
        "Pre Sale": "get-count-presales",
        "Tele Sale": "get-count-telesales",
        "Field Sale": "get-count-leadsstatus"
      };
      
      if (countApiMap[role]) {
        path = `${baseUrl}cleaningappfunctions/crm/app/v1/${countApiMap[role]}`;
      }
    }

    const response = await axios.get(path, {
      headers: {
        "auth-token": token,
      },
    });

    return response;
  } catch (error) {
    console.error("Error counting leads:", error);
    throw error;
  }
});


export const getLeadReladedList = async (id) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-related-list/${id}`, {
      headers: {
        "auth-token": token,
      },
    });
    // console.log("<<<<<<???????????????????LeadReduxresponse>>>>>>>>>>>>>",response)
    return response;
  } catch (error) {
    throw error;
  }
};
